import { useUser } from '@/lib/auth';
import { assertIsDefined } from '@/utils/assert';

export const useOrganizationId = () => {
  const user = useUser();
  const { organization } = user.membership;

  const organizationId = organization.id;

  assertIsDefined(organizationId, 'organizationId');

  return organizationId;
};
